import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/layout'

Vue.use(Router)

const initRouterMap = [
  {
    path: '/login',
    meta: {},
    component: () => import('@/views/login/login')
  }
]

const authRouterMap = [
  {
    path: '/',
    redirect: '/home/index',
    meta: {}
  },
  {
    path: '/home',
    component: Layout,
    redirect: '/home/index',
    meta: {
      name: '首页',
      icon: 'home'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/home/index'),
        meta: {}
      }
    ]
  },
  {
    path: '/announcement',
    component: Layout,
    auth: ['announcementModule'],
    redirect: '/announcement/index',
    meta: {
      name: '公告管理',
      icon: 'announcement'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/announcement/index'),
        meta: {}
      }
    ]
  },
  {
    path: '/employee',
    component: Layout,
    redirect: '/employee/index',
    auth: ['employeeModule'],
    meta: {
      name: '员工管理',
      icon: 'employee'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/employee/index'),
        meta: {
          name: '员工管理'
        }
      },
      {
        path: 'items',
        component: () => import('@/views/employee/items'),
        meta: {
          name: '员工列表'
        }
      },
      {
        path: 'details/:id',
        component: () => import('@/views/employee/details'),
        meta: {}
      },
      {
        path: 'add',
        component: () => import('@/views/employee/add'),
        meta: {
          name: '员工入职'
        },
        auth: ['employeeModuleAddEmployee']
      },
      {
        path: 'department',
        component: () => import('@/views/employee/department'),
        meta: {
          name: '部门管理'
        }
      }
      // {
      //   path: 'contract',
      //   component: () => import('@/views/employee/contract'),
      //   meta: {
      //     name: '劳动合同'
      //   }
      // }
    ]
  },
  {
    path: '/attend',
    component: Layout,
    redirect: '/attend/index',
    auth: ['attendModule'],
    meta: {
      name: '考勤管理',
      icon: 'attend'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/attend/index'),
        meta: {
          name: '考勤管理'
        }
      },
      {
        path: 'day',
        component: () => import('@/views/attend/day'),
        meta: {
          name: '每日考勤'
        }
      },
      {
        path: 'month',
        component: () => import('@/views/attend/month'),
        meta: {
          name: '月份统计'
        }
      },
      {
        path: 'emp',
        component: () => import('@/views/attend/emp'),
        meta: {
          name: '员工考勤'
        }
      }
      // {
      //   path: 'myItems',
      //   component: () => import('@/views/attend/myItems'),
      //   meta: {
      //     name: '我的考勤'
      //   }
      // }
    ]
  },
  // {
  //   path: '/teamwork',
  //   component: Layout,
  //   redirect: '/teamwork/index',
  //   auth: ['teamWorkModule'],
  //   meta: {
  //     name: '团队协作',
  //     icon: 'teamwork'
  //   },
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/teamwork/index'),
  //       meta: {
  //         name: '团队协作'
  //       }
  //     },
  //     {
  //       path: 'add',
  //       component: () => import('@/views/teamwork/add'),
  //       meta: {
  //         name: '添加任务'
  //       }
  //     },
  //     {
  //       path: 'details/:id',
  //       component: () => import('@/views/teamwork/details'),
  //       meta: {}
  //     }
  //   ]
  // },
  {
    path: '/tandeAudit',
    component: Layout,
    redirect: '/tandeAudit/index',
    auth: ['TAndEAuditModule'],
    meta: {
      name: 'T&E审核',
      icon: 'attend'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/tandeAudit/index'),
        meta: {
          name: 'T&E列表'
        },
        auth: ['TAndEAuditModule']
      },
      {
        path: 'group',
        component: () => import('@/views/tandeAudit/group'),
        meta: {
          name: '审核人员'
        },
        auth: ['TAndEAuditModuleAuditEmp']
      },
      // {
      //   path: 'emp',
      //   component: () => import('@/views/tandeAudit/emp'),
      //   meta: {
      //     name: '员工报告'
      //   },
      //   auth: ['TAndEAuditModuleAuditEmp']
      // },
      {
        path: 'search',
        component: () => import('@/views/tandeAudit/search'),
        meta: {
          name: '报告搜索'
        },
        auth: ['TAndEAuditModuleSearchEmp']
      },
      {
        path: 'setting',
        component: () => import('@/views/tandeAudit/setting'),
        meta: {
          name: '设置'
        },
        auth: ['TAndEAuditModuleSetting']
      }
    ]
  },
  {
    path: '/project',
    component: Layout,
    redirect: '/project/index',
    auth: ['projectModule'],
    meta: {
      name: '项目管理',
      icon: 'attend'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/project/index'),
        meta: {
          name: '项目列表'
        },
        auth: ['projectModule']
      },
      {
        path: 'add',
        component: () => import('@/views/project/add'),
        meta: {
          name: '添加项目'
        },
        auth: ['projectModuleCreateProject']
      }
    ]
  },
  {
    path: '/customer',
    component: Layout,
    redirect: '/customer/index',
    auth: ['customerModule'],
    meta: {
      name: '客户管理',
      icon: 'attend'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/customer/index'),
        meta: {
          name: '客户管理'
        },
        auth: ['customerModule']
      }
    ]
  },
  {
    path: '/approval',
    component: Layout,
    redirect: '/approval/setting',
    auth: ['approvalModule'],
    meta: {
      name: '流程审批',
      icon: 'approval'
    },
    children: [
      // {
      //   path: 'index',
      //   component: () => import('@/views/approval/index'),
      //   meta: {
      //     name: '流程审批'
      //   },
      //   auth: ['approvalModule']
      // },
      {
        path: 'setting',
        component: () => import('@/views/approval/setting'),
        meta: {
          name: '流程设置'
        },
        auth: ['approvalModule']
      }
      // {
      //   path: 'overtime',
      //   component: () => import('@/views/approval/overtime'),
      //   meta: {
      //     name: '加班'
      //   }
      // },
      // {
      //   path: 'holiday',
      //   component: () => import('@/views/approval/holiday'),
      //   meta: {
      //     name: '请假'
      //   }
      // },
      // {
      //   path: 'airTickets',
      //   component: () => import('@/views/approval/airTickets'),
      //   meta: {
      //     name: '机票'
      //   }
      // }
    ]
  },
  // {
  //   path: '/auth',
  //   component: Layout,
  //   redirect: '/auth/index',
  //   meta: {
  //     name: '权限管理',
  //     icon: 'auth'
  //   },
  //   children: [{
  //     path: 'index',
  //     component: () => import('@/views/auth/index'),
  //     meta: {
  //       name: '权限管理'
  //     }
  //   }]
  // },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/index',
    auth: ['userModule'],
    meta: {
      name: '账户管理',
      icon: 'user'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/user/index'),
        meta: {
          name: '账户管理'
        }
      },
      {
        path: 'details/:id',
        component: () => import('@/views/user/details'),
        meta: {}
      }
    ]
  },
  {
    path: '/talent',
    component: Layout,
    redirect: '/talent/items',
    auth: ['talentModule'],
    meta: {
      name: '人才库',
      icon: 'employee'
    },
    children: [
      // {
      //   path: 'index',
      //   component: () => import('@/views/talent/index'),
      //   meta: {
      //     name: '信息统计'
      //   }
      // },
      {
        path: 'items',
        component: () => import('@/views/talent/items'),
        meta: {
          name: '信息列表'
        }
      },
      {
        path: 'add',
        component: () => import('@/views/talent/add'),
        auth: ['talentModuleAdd'],
        meta: {
          name: '信息录入'
        }
      },
      {
        path: 'details/:id',
        component: () => import('@/views/talent/details'),
        meta: {}
      }
    ]
  },
  {
    path: '/logs',
    component: Layout,
    redirect: '/logs/index',
    auth: ['logsModule'],
    meta: {
      name: '日志管理',
      icon: 'logs'
    },
    children: [{
      path: 'index',
      component: () => import('@/views/logs/index'),
      meta: {
      }
    }]
  }
]

export const authRouter = authRouterMap

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...initRouterMap
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js